import { render, staticRenderFns } from "./VFinalizedCheckout.vue?vue&type=template&id=0c6709fd&"
import script from "./VFinalizedCheckout.vue?vue&type=script&lang=js&"
export * from "./VFinalizedCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports